import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StateContext } from "./contexts/StateContext";
import "./assets/styles/App.css";
import Header from "./components/Header";
import Pizza from "./components/Pizza/Pizza";
import Cart from "./components/Cart/Cart";
import Footer from "./components/Footer";
import Order from "./components/Order/Order";
import OrderHistory from "./components/Order/OrderHistory";

const App = () => {
  const { showOrder, showOrderHistory } = useContext(StateContext);

  let content = (
    <>
      <Row className="h-100">
        <Col className="h-100">
          <Pizza />
        </Col>
        <Col className="h-100">
          <Container className="cart-box h-100 border border-dark rounded-2 pb-4">
            <Cart />
          </Container>
        </Col>
      </Row>
    </>
  );

  if (showOrder) content = <Order />;

  if (showOrderHistory) content = <OrderHistory />;

  return (
    <Container fluid>
      <Row>
        <Col>
          <div className="d-flex flex-column vh-100 overflow-hidden">
            <Header />
            <Row className="h-100 mb-3 mx-0 overflow-hidden">
              <Container fluid className="h-100">
                {content}
              </Container>
            </Row>
            <Footer />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default App;
